import React from "react";
import { styled } from "@mui/material/styles";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { CrumbTitle } from "./CrumbTitles";
import StyledLink from "../StyledLink/StyledLink";
import { RandomTextSkeleton } from "../../../Skeleton/RandomTextSkeleton";

const ActiveCrumb = styled("span", {
  shouldForwardProp: (prop) =>
    prop !== "color" && prop !== "variant" && prop !== "sx",
  name: "ActiveCrumb",
})({});

export default function Breadcrumb(props: { pageTitle?: string | undefined }) {
  const { pageTitle } = props;
  const pathname = window.location.pathname;
  const pathArr = pathname.split("/");

  const handlePath = (index: number) => {
    let retVal = "";
    for (let x = 1; x <= index; x++) {
      retVal += "/" + pathArr[x];
    }
    return retVal;
  };

  const generateActiveCrumb = (path: string) => (pageTitle ? pageTitle : path);

  return (
    <Breadcrumbs
      sx={{
        display: "flex",
        justifyContent: "left",
        "& ol": {
          textTransform: "capitalize",
          color: "text.secondary",
        },
      }}
    >
      {pathArr.map((path, index) =>
        index !== 0 ? (
          index !== pathArr.length - 1 ? (
            <StyledLink
              sx={{
                textDecoration: "none",
                color: "text.primary",
              }}
              to={handlePath(index)}
              key={index}
            >
              {CrumbTitle(path)}
            </StyledLink>
          ) : (
            <ActiveCrumb
              sx={{
                color: "text.primary",
                fontWeight: "600",
              }}
              key={index}
            >
              {pageTitle !== "" ? (
                CrumbTitle(generateActiveCrumb(path))
              ) : (
                <RandomTextSkeleton />
              )}
            </ActiveCrumb>
          )
        ) : null
      )}
    </Breadcrumbs>
  );
}
